import Vue from 'vue';
import Vue2TouchEvents from 'vue2-touch-events';
import PinchZoom from 'vue-pinch-zoom';
import VueScrollactive from 'vue-scrollactive';

import App from './App.vue';
import router from './router';
import './registerServiceWorker';
import { ClickOutside } from '@/directives/ClickOutside';

Vue.config.productionTip = false;
Vue.use(Vue2TouchEvents);
Vue.component('pinch-zoom', PinchZoom);
Vue.use(VueScrollactive);
Vue.directive('click-outside', ClickOutside);

if (window.innerWidth > 550) {
    document.body.innerHTML = 'Aplikacja przeznaczona jest na urządzenia mobilne. <br /> Zostaniesz przekierowana do Landing Page.';
    setTimeout( function () {
        window.location.replace('https://ekoporadnik.jastrzebie.pl');
    }, 500);
} else {
    new Vue({
        router,
        render: h => h(App),
    }).$mount('#app');
}
